import React from "react";
import { getTrackBackground, Range } from "react-range";

const Slider3 = ({ min, max, step, value, setValue, isDisabled }) => {
  return (
    <Range
      min={min}
      max={max}
      step={step}
      values={[value]}
      disabled={isDisabled}
      onChange={(values) => setValue(values)}
      renderTrack={({ props, children }) => (
        <div
          className="custom-slider"
          onMouseDown={props.onMouseDown}
          onTouchStart={props.onTouchStart}
          style={{
            ...props.style,
            height: "36px",
            display: "flex",
            width: "100%",
          }}
        >
          <div
            ref={props.ref}
            style={{
              height: "4px",
              width: "100%",
              borderRadius: "4px",
              background: getTrackBackground({
                values: [value],
                colors: ["#9B59B6", "#ffffff"],
                min: min,
                max: max,
                rtl: false,
              }),
              alignSelf: "center",
            }}
          >
            {children}
          </div>
        </div>
      )}
      renderThumb={({ props }) => (
        <div
          {...props}
          style={{
            ...props.style,
            width: "16px",
            height: "16px",
            borderRadius: "50%",
            backgroundColor: "#ffffff",
            border: "4px solid #9B59B6",
          }}
        />
      )}
    />
  );
};

export default Slider3;
